import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {RouteMapSymbolService} from 'app/blocks/service/api/route-map-symbol.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IRouteMapSymbol} from 'app/blocks/model/route-map-symbol.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {RouteMapSymbol} from 'app/blocks/model/route-map-symbol.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class RouteMapSymbolResource extends AbstractEntityResource<IRouteMapSymbol> {
    constructor(routeMapSymbolService: RouteMapSymbolService, router: Router) {
        super(
            Resource.ROUTE_MAP_SYMBOLS,
            routeMapSymbolService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.ROUTE_MAP_SYMBOLS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.ROUTE_MAP_SYMBOLS),
            (entity?) => new RouteMapSymbol(entity),
            (entity) => entity.code
        );
    }
}
